/*global google*/

import React from 'react';
import { Marker } from 'react-google-maps';
import InfoBox from 'shims/reactGoogleMapsInfoBox';

import { ROLES } from 'config/constants';
import { getAbbreviateNumber } from 'utils/getAbbreviateNumber';
import { InfoBoxItem } from '../InfoboxItem';
import Spiderfy from './Spiderfy';

const CLUSTER_ICON_SIZE = { width: 50, height: 63 };
/** White circle center on marker-clasterer.svg (50×63). */
const CLUSTER_LABEL_ORIGIN = { x: 25, y: 22 };

const Markers = ({
  listData = [],
  onMouseOver,
  onMouseOut,
  onMarkerClick,
  handleClustererMarkerClick,
  activeLocationId,
  openedInfoBox,
  activeMarkerImg,
  activeLocationData,
  isInfoProcessed,
}) => {
  const listMarkers = [];

  listData.forEach((item) => {
    const {
      id,
      count,
      radius,
      point = {},
      reserchSite: { id: researchId, group = '', locations = [] } = {},
      type,
    } = item;
    const isInactiveResearchSite = group === ROLES.INACTIVE_RESEARCH_SITE;
    const activeMarkerIcon = isInactiveResearchSite
      ? './assets/images/svg/change-map-icon-inactive.svg'
      : activeMarkerImg;
    const markerIcon = isInactiveResearchSite
      ? './assets/images/svg/inactive-pin.svg'
      : './assets/images/svg/default-map-icon.svg';

    if (type === 2) {
      // Native Marker label — avoids MarkerWithLabel's React 17
      // unstable_renderSubtreeIntoContainer (unsupported in React 18).
      listMarkers.push(
        <Marker
          key={id}
          position={{ lat: point.y, lng: point.x }}
          icon={{
            url: './assets/images/svg/marker-clasterer.svg',
            scaledSize: new google.maps.Size(
              CLUSTER_ICON_SIZE.width,
              CLUSTER_ICON_SIZE.height,
            ),
            anchor: new google.maps.Point(
              CLUSTER_ICON_SIZE.width / 2,
              CLUSTER_ICON_SIZE.height,
            ),
            labelOrigin: new google.maps.Point(
              CLUSTER_LABEL_ORIGIN.x,
              CLUSTER_LABEL_ORIGIN.y,
            ),
          }}
          label={{
            text: String(getAbbreviateNumber(count)),
            color: '#474D55',
            fontSize: count > 999 ? '10px' : '12px',
            fontWeight: '600',
          }}
          onClick={() =>
            handleClustererMarkerClick(
              { lat: point.y, lng: point.x },
              radius,
              count,
            )
          }
        />,
      );
    }

    if (type === 1) {
      locations.forEach(
        ({ locationAddress: { point = {} } = {}, id: locationId = '' }) => {
          listMarkers.push(
            <Marker
              key={locationId}
              icon={{
                url:
                  activeLocationId === locationId &&
                  openedInfoBox === activeLocationId
                    ? activeMarkerIcon
                    : markerIcon,
              }}
              position={{ lat: point.y, lng: point.x }}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut}
              params={{ id: researchId, locationId }}
            >
              {activeLocationId === locationId &&
                openedInfoBox === activeLocationId && (
                  <InfoBox
                    options={{
                      closeBoxURL: ``,
                      enableEventPropagation: true,
                      pixelOffset:
                        group === 'InactiveResearchSite'
                          ? new google.maps.Size(-157, -13)
                          : new google.maps.Size(-293, -13),
                    }}
                  >
                    <InfoBoxItem
                      group={group}
                      activeLocationData={activeLocationData ?? {}}
                      isInfoProcessed={isInfoProcessed}
                    />
                  </InfoBox>
                )}
            </Marker>,
          );
        },
      );
    }
  });

  return <Spiderfy onSpiderClick={onMarkerClick}>{listMarkers}</Spiderfy>;
};

export { Markers };
